import { useNavigation } from 'react-router';
import styles from './NavigationProgress.module.scss';

/**
 * Shows a loading indicator during route navigation.
 * Uses React Router's useNavigation() hook to detect navigation state.
 *
 * Navigation states:
 * - "idle": No navigation in progress
 * - "loading": Route is loading (lazy chunk or loader running)
 * - "submitting": Form is being submitted
 */
export function NavigationProgress() {
  const navigation = useNavigation();
  const isNavigating = navigation.state !== 'idle';

  if (!isNavigating) {
    return null;
  }

  return (
    <div className={styles.progressContainer} role="progressbar" aria-label="Loading page">
      <div className={styles.progressBar} />
    </div>
  );
}

export default NavigationProgress;
